(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.weaver_takeover = {

    activateInnerItem: function(wrapper, item) {
      document.querySelectorAll('.inner-item').forEach((itemElement) => {
        itemElement.classList.remove('active');
      });
      let activatingItem = wrapper.querySelector('[data-item="' + item + '"]');
      if (activatingItem != null) {
        activatingItem.classList.add('active');
        // scroll to its top
        wrapper.scrollTo(0,0);
        
        let firstFocusElement = activatingItem.querySelector('.nav-column a');
        if (firstFocusElement != null) {
          firstFocusElement.focus();
        }
      }

    },

    activateCover: function(cover) {
      const weaverTakeover = Drupal.behaviors.weaver_takeover;

      // actions when takeoverCover clicked
      if (cover != null) {
        cover.addEventListener('click', (e) => {
          e.preventDefault();
          weaverTakeover.closeAll();
        });
      }
    },

    activateTakeover: function(type, button, cover) {
      const weaverTakeover = Drupal.behaviors.weaver_takeover;

      // takeover open/close
      button.addEventListener('click', function(e) {
        e.preventDefault();
        weaverTakeover.toggleTakeover(type, button, cover);
      });

      document.addEventListener('keydown', function(e) {
        if (e.code == 'Enter' && e.target == button) {
          weaverTakeover.toggleTakeover(type, button, cover);
        }
        if (e.code == 'Escape' && weaverTakeover.checkOpen(type)) {
          weaverTakeover.toggleTakeover(type, button, cover);
        }
      });
    },

    checkClosed: function(type) {
        if (document.documentElement.classList.contains('takeover-' + type + '-open')) {
            return false;
        }
        return true;
    },

    checkOpen: function(type) {
        if (document.documentElement.classList.contains('takeover-' + type + '-open')) {
            return true;
        }
        return false;
    },

    closeAll: function() {
      let types = ['menu', 'search', 'side-butt'];
      types.forEach((type) => {
        document.documentElement.classList.remove('takeover-' + type + '-open');
        document.documentElement.classList.add('takeover-' + type + '-closed');
      });
      
      this.setMenuLinksInactive();


        // take care of accessibility
        // this.toggleTrueFalse(takeover, 'aria-hidden');
        // this.toggleTrueFalse(button, 'aria-expanded');
    },

    mobileTakeoverChanges: function(takeover) {
      // let childNav;
      // let parentLinks = takeover.querySelectorAll('ul.nav > li.nav-item > .nav-link');
      
      // if (parentLinks) {
      //   parentLinks.forEach((parentLink) => {
      //     parentLink.addEventListener('click', (e) => {
      //       childNav = parentLink.parentNode.querySelector('ul.menu');
      //       if (childNav != null) {
      //         e.preventDefault();
      //         childNav.classList.toggle('active');
      //       }
      //     });
      //   });
      // }
    },

    openClose: function(type, button, takeover) {
      document.documentElement.classList.toggle('takeover-' + type + '-open');
      document.documentElement.classList.toggle('takeover-' + type + '-closed');

      // take care of accessibility
      this.toggleTrueFalse(takeover, 'aria-hidden');
      this.toggleTrueFalse(button, 'aria-expanded');

      // mark originating button for later re-focus
      if (this.checkOpen(type)) {
        button.dataset.triggering = true;
      }

      // if closed, return focus to button marked as data-triggering=true
      if (this.checkClosed(type)) {
        let trigger = document.querySelector('[data-trigger="true"]');

        if (trigger != null) {
          trigger.focus();
          trigger.dataset.triggering = false;
        }
      }
    },

    setMenuLinksInactive: function() {
      const activeMenuLinks = document.querySelectorAll('#header .nav-link.active');
      if (activeMenuLinks != null) {
        activeMenuLinks.forEach((menuLink) => {
          menuLink.classList.remove('active');
        });
      }
    },

    toggleMenuLinks: function(button) {
      this.setMenuLinksInactive();
      button.classList.add('active');
    },

    toggleTakeover: function(type, button, cover) {
      const weaverTakeover = Drupal.behaviors.weaver_takeover;

      const header = document.getElementById('header');
      let takeover = document.getElementById('takeover-' + type);
      let toggleButton;
      let icon;
      let activeItem = document.querySelector('.inner-item.active');

      // ensure all other takeovers are closed
      switch (type) {

        case 'mobile-menu':

          if (this.checkOpen('search')) {
            this.toggleTakeover('search', button, cover);
           }
          if (this.checkOpen('side-butt')) {
            this.toggleTakeover('side-butt', button, cover);
          }
          break;

        case 'menu':
          weaverTakeover.activateInnerItem(takeover, button.dataset.item);

          // change scrollbar colour if active item
          let activeItem = takeover.querySelector('.inner-item.active');
          if (activeItem != null && activeItem.dataset != null) {
            let colour = activeItem.dataset.colour;
            takeover.dataset.scrollbar = colour;
          }

          this.toggleMenuLinks(button);
          
          toggleButton = document.querySelector('#takeover-button a');

          if (this.checkOpen('search')) {
            this.toggleTakeover('search', button, cover);
           }
          if (this.checkOpen('side-butt')) {
            this.toggleTakeover('side-butt', button, cover);
          }
                      
          break;
  
        case 'search':
          toggleButton = document.querySelector('a.search-button');
          console.log(toggleButton);

          // if (this.checkOpen('mobile-menu')) {
          //   this.toggleTakeover('mobile-menu', button, cover);
          // }
          if (this.checkOpen('menu')) {
            this.toggleTakeover('menu', button, cover);
          }
          if (this.checkOpen('side-butt')) {
            this.toggleTakeover('side-butt', button, cover);
          }

          // set focus on first input
          let firstInput = takeover.querySelector('input');
          setTimeout(() => {
            if (firstInput != null) {
              firstInput.focus();
            }
          }, 500);

          break;

        case 'side-butt':
          weaverTakeover.activateInnerItem(takeover, button.dataset.item);

          toggleButton = document.querySelector('a.side-button');

          if (this.checkOpen('mobile-menu')) {
            this.toggleTakeover('mobile-menu', button, cover);
          }
          if (this.checkOpen('menu')) {
            this.toggleTakeover('menu', button, cover);
          }
          if (this.checkOpen('search')) {
            this.toggleTakeover('search', button, cover);
          }

          break;
      }

      // expand/collapse menu

      // if side-butt or menu, check if it should close or toggle
      // if side-butt or menu is open and a different  button is clicked, toggle the active item instead of closing
      // always toggle Search no problem
      if (type == 'search') {
        weaverTakeover.openClose(type, button, takeover);
      } else {

        // always toggle if nothing open
        if (this.checkOpen('menu') == false && this.checkOpen('side-butt') == false) {
          
          // special case for .mobile-takeover-close
          if (button.classList.contains('mobile-takeover-close') == false) {
            weaverTakeover.openClose(type, button, takeover);
          }

        } else {
          // close if button clicked that is same as the active sidebutt or menu item
          if (this.checkOpen('side-butt')) {

            // if clicking on nav when side-butt open, open nav with activeItem loaded
            if (button.dataset.target == 'takeover-menu') {
              weaverTakeover.openClose(type, button, takeover);
              weaverTakeover.activateInnerItem(document.getElementById('takeover-menu'), button.dataset.item);

            } else {
              
              if (activeItem != null && button.dataset.item == activeItem.dataset.item) {
                weaverTakeover.openClose(type, button, takeover);
                this.setMenuLinksInactive();
              }
            }
          }
          if (this.checkOpen('menu')) {

            // if clicking on side-butt when nav open, open side-butt with activeItem loaded
            if (button.dataset.target == 'takeover-side-butt') {
              weaverTakeover.openClose(type, button, takeover);
              weaverTakeover.activateInnerItem(document.getElementById('takeover-side-butt'), button.dataset.item);

            } else {
              if (activeItem != null && button.dataset.item == activeItem.dataset.item) {
                weaverTakeover.openClose(type, button, takeover);
                this.setMenuLinksInactive();
              }
            }
          }
        }
      }

      // always close when close button clicked
      if (button.dataset.close == 1) {
        weaverTakeover.openClose(type, button, takeover);
      }

      this.trapFocus(type, button, takeover);
    },

    toggleTrueFalse: function(element, attribute) {

        let attributeStatus = element.getAttribute(attribute);

        if (attributeStatus == 'true') {
          element.setAttribute(attribute, 'false');
        } else {
          element.setAttribute(attribute, 'true');
        }
    },

    trapFocus: function(type, button, takeover) {

      const innerFocusableElements = takeover.querySelectorAll('a, button, input');

      // put all menu items into or out of tabindex
      if (this.checkOpen(type)) {

        innerFocusableElements.forEach((focusElement) => {
          focusElement.setAttribute('tabindex', 0);
        });

     } else {

        innerFocusableElements.forEach((focusElement) => {
            focusElement.setAttribute('tabindex', -1);
        });
      }

      // focus on first element
      if (type == 'menu') {
        takeover.querySelector('.nav-column a').focus();
      } else {
        innerFocusableElements[0].focus();
      }

    },

    attach: function (context, settings) {

      // ensures javascript runs only once per page load and not with every ajax call
      $(once('weaver_takeover', 'body', context)).each(function () {
        const weaverTakeover = Drupal.behaviors.weaver_takeover;

        // add closed classes
        document.documentElement.classList.add('takeover-mobile-menu-closed');
        document.documentElement.classList.add('takeover-menu-closed');
        document.documentElement.classList.add('takeover-search-closed');
        document.documentElement.classList.add('takeover-side-butt-closed');

        // SEARCH
        // #TODO why does this need to be timedout ? it doesn't work otherwise
        setTimeout(() => {
          let takeoverSearch = document.getElementById('takeover-search');
          let searchButtons = document.querySelectorAll('a[data-target="takeover-search"]');
          let searchCover = document.getElementById('takeover-search-cover');

          if (takeoverSearch) {

            // hide when page loads or else get FOUC
            takeoverSearch.classList.add('launch');
            setTimeout(() => {
              takeoverSearch.classList.remove('launch');
            }, 1000);

            if (searchButtons != null) {
              searchButtons.forEach((searchButton) => {
                weaverTakeover.activateTakeover('search', searchButton, searchCover);
              });
              weaverTakeover.activateCover(searchCover);
            }
          }
        }, 1000);

        // SIDE BUTT
        let takeoverSidebutt = document.getElementById('takeover-side-butt');
        let sidebuttButtons = document.querySelectorAll('a[data-target="takeover-side-butt"]');
        let sidebuttCover = document.getElementById('takeover-side-butt-cover');

        if (takeoverSidebutt) {

          // hide when page loads or else get FOUC
          takeoverSidebutt.classList.add('launch');
          setTimeout(() => {
            takeoverSidebutt.classList.remove('launch');
          }, 1000);

          if (sidebuttButtons) {
            sidebuttButtons.forEach((sidebuttButton) => {
              weaverTakeover.activateTakeover('side-butt', sidebuttButton, sidebuttCover);
            });
            weaverTakeover.activateCover(sidebuttCover);
          }
        }

        // MENU
        let takeover = document.getElementById('takeover-menu');
        let takeoverButtons = document.querySelectorAll('a[data-target="takeover-menu"]');
        let takeoverCover = document.getElementById('takeover-menu-cover');
       
      	if (takeover) {

      		if (takeoverButtons) {
            takeoverButtons.forEach((takeoverButton) => {
              weaverTakeover.activateTakeover('menu', takeoverButton, takeoverCover);
            });
            weaverTakeover.activateCover(takeoverCover);
          }
        }

        // MENU
        let mobileTakeover = document.getElementById('takeover-mobile-menu');
        let mobileTakeoverButtons = document.querySelectorAll('a[data-target="takeover-mobile-menu"]');
        let mobileTakeoverCover = document.getElementById('takeover-mobile-menu-cover');
       
        if (takeover) {

          if (mobileTakeoverButtons) {
            mobileTakeoverButtons.forEach((mobileTakeoverButton) => {
              weaverTakeover.activateTakeover('mobile-menu', mobileTakeoverButton, mobileTakeoverCover);
            });
          }
        }
      });
    }
  };

})(jQuery, Drupal, once);
